import { useCallback, useEffect, useRef } from 'react';

export const useDebouncedAddEventListener = <
  Event extends keyof WindowEventMap,
  Handler extends (event: WindowEventMap[Event]) => void,
>(
  event: Event,
  handler: Handler,
) => {
  const timeout = useRef<NodeJS.Timeout>();
  const debouncedAddEventListener = useCallback(() => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      window.removeEventListener(event, handler);
      window.addEventListener(event, handler);
    });
  }, [event, handler]);
  useEffect(() => {
    debouncedAddEventListener();

    return () => {
      clearTimeout(timeout.current);
      window.removeEventListener(event, handler);
    };
  }, [debouncedAddEventListener, event, handler]);
};
